import React, { useContext, useEffect, useRef, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { Toast } from 'primereact/toast';
import Loader from '../../../Base/Components/Loader/Loader';
import { getMasterWipOpen, getMasterWipOpenDetail } from '../../../API/Planning/MasterWip/MasterWipRequest';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { colors } from '../../../Styles/Colors';
import { formatNumberDecimal } from '../../../Base/Services/FormatTemplate';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { toastShow } from '../../../Base/Services/ToastService';
import { formatProductionCard } from '../../../Base/Services/TemplatesServices';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

const MasterWipScreen = ({get = 1, statusTemplate}) => {

    const toast = useRef(null);
    const { userAuth } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [select, setSelect] = useState([]);
    const [detail, setDetail] = useState(null);
    const [details, setDetails] = useState([])
    const { config } = useContext(ConfigContext);
    const [selectedDetail, setSelectedDetail] = useState([]);


    const getInfo = async () => {
        setLoading(true);
        const result = await getMasterWipOpen();
        setData(result);
        setLoading(false);
    }

    const getDetail = async (data) => {
        setLoading(true);
        const result = await getMasterWipOpenDetail(data.IdSalesOrderDetail);
        setDetails(result);
        setLoading(false);
    }

    const barPorcentaje = (e, field, color) => {
        let width = e[field] ? e[field] : 0;
        if (width > 100) width = 100;

        return <div className='col-12' style={{ height: '100%', position: 'relative' }}>
            <div style={{ height: '100%', backgroundColor: color, width: width + '%' }}>
            </div>
            <div className='text-center col-12 text-bold' style={{ position: 'absolute', top: 0, }}>
                {e[field] ? formatNumberDecimal(e[field]) : 0.00} %
            </div>
        </div>
    }

    const ExPercent = (e) => {
        const color = e?.MaxPercent < e.ExPercent ? colors.borderColorCotton : config?.theme === 'Light' ? '#000' : '#FFF';
        return <div className='col-12 text-bold text-center' style={{ height: '100%', position: 'relative', color: color }}>
            {e?.ExPercent ? formatNumberDecimal(e?.ExPercent) : 0.00} %
        </div>
    }

    const openDialogPCs = (e) => {
        let { data } = e;
        if (data.CantPC) {
            setDetail(data);
            getDetail(data);
        } else {
            toastShow(toast, 'warn', 'Advertencia', 'No hay Production Cards', 3000);
        }
    }

    const onHide = () => {
        setDetail(null);
    }

    const columns = [
        {
            field: 'IdSalesOrderDetail',
            header: 'IdSalesOrderDetail',
            headerEn: '',
            className: 'Xsmall',
            hidden: userAuth.IdRol === 1,
        },
        
        {
            field: 'CantPC',
            header: 'No PCs',
            headerEn: '',
            className: 'XXsmall',
            Format: 'Right',
            Sumary: 'sum',
            Frozen: true,
            alignFrozen: 'left',
            onCellDoubleClicked: openDialogPCs
        },
        {
            field: 'CreateDate',
            header: 'Fecha Creación',
            headerEn: 'Create Date',
            Format: 'Date',
            Frozen: true,
            alignFrozen: 'left',
            onCellDoubleClicked: openDialogPCs
        },
        {
            field: 'PO',
            header: 'PO',
            headerEn: 'PO',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            onCellDoubleClicked: openDialogPCs
        },
        {
            field: 'SalesOrder',
            header: 'Orden de Venta',
            headerEn: 'Sales Order',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            onCellDoubleClicked: openDialogPCs
        },
        {
            field: 'Color',
            header: 'Color',
            headerEn: '',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            Sumary: 'count',
            onCellDoubleClicked: openDialogPCs
        },
        {
            field: 'OrderStatus',
            header: 'Estado de Orden',
            headerEn: 'Order Status',
            className: 'Xsmall',
        },
        {
            field: 'Customer',
            header: 'Cliente',
            headerEn: 'Customer',
            className: 'large',
        },
        {
            field: 'Buyer',
            header: 'Comprador',
            headerEn: 'Buyer',
            className: 'Xsmall',
        },
        {
            field: 'Season',
            header: 'Temporada',
            headerEn: 'Season',
            className: 'Xsmall',
        },
        {
            field: 'OrderType',
            header: 'Tipo de Orden',
            headerEn: 'Order Type',
            className: 'small',
        },
        {
            headerName: 'Closing Control',
            headerNameEn: 'Closing Control',
            children: [
                {
                    field: 'CerradoVentas',
                    header: 'Ventas',
                    headerEn: 'Sales',
                    className: 'small',
                    Format: 'Checkbox',
                },
                {
                    field: 'CerradoPlanning',
                    header: 'Planning',
                    headerEn: 'Planning',
                    className: 'small',
                    Format: 'Checkbox',
                },
            ]
        },
        {
            headerNameEn: 'Status',
            headerName: 'Estado',
            children: [
                {
                    headerName: 'Laboratorio',
                    headerNameEn: 'Laboratory',
                    children: [
                        {
                            field: 'LabDipStatus',
                            header: 'LabDipStatus',
                            headerEn: 'LabDipStatus',
                            className: 'Xsmall',
                        },
                        {
                            field: 'LabDip',
                            header: 'LabDip',
                            headerEn: 'LabDip',
                            className: 'mediums',
                        },
                        {
                            field: 'Densidad',
                            header: 'Densidad',
                            headerEn: 'Density',
                            className: 'Xsmall',
                        },
                    ]
                },
            ]
        },
        {
            headerName: 'Estilos',
            headerNameEn: 'Styles',
            children: [
                {
                    field: 'Category',
                    header: 'Categoria',
                    headerEn: 'Category',
                    className: 'Xsmall',
                },
                {
                    field: 'Style',
                    header: 'Estilo',
                    headerEn: 'Style',
                    className: 'large',
                },
                {
                    field: 'Width',
                    header: 'Ancho',
                    headerEn: 'Width',
                    className: 'Xsmall',
                },
                {
                    field: 'StyleType',
                    header: 'Tipo de Estilo',
                    headerEn: 'Style Type',
                    className: 'Xsmall',
                },
            ]
        },
        {
            headerName: 'Orden',
            headerNameEn: 'Order',
            children: [
                {
                    headerName: 'Net',
                    children: [
                        {
                            field: 'KgsAcabado',
                            header: 'Kgs',
                            headerEn: 'Kgs',
                            className: 'Xsmall',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'YdsAcabado',
                            header: 'Yds',
                            headerEn: 'Yds',
                            className: 'Xsmall',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
                {
                    headerName: 'Plan',
                    headerNameEn: 'Plan',
                    children: [
                        {
                            field: 'KgsAcabadoLoss',
                            header: 'Kgs',
                            className: 'Xsmall',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'YdsAcabadoLoss',
                            header: 'Yds',
                            className: 'Xsmall',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
            ],
        },
        {
            headerName: 'Producción Cards',
            headerNameEn: 'ProductionCards',
            children: [
                {
                    field: 'KgsPCO',
                    header: 'Issue',
                    headerEn: 'Issue',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsPCOB',
                    header: 'Balance',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Greige Store',
            headerNameEs: 'Greige Store',
            children: [
                {
                    field: 'KgsPCC',
                    header: 'Issue',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsBC',
                    header: 'Balance',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Preparación',
            headerNameEn: 'Preparation',
            children: [
                {
                    field: 'KgsP',
                    header: 'Kgs',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsBP',
                    header: 'Balance',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Tintorería',
            headerNameEn: 'Dyeing',
            children: [
                {
                    field: 'KgsT',
                    header: 'Kgs',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsBT',
                    header: 'Balance',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'BalancePCTinto',
                    header: 'BalancePC',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Acabado',
            headerNameEn: 'Finish',
            children: [
                {
                    field: 'KgsAC',
                    header: 'Kgs',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsBA',
                    header: 'Balance',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'BalancePCAcabado',
                    header: 'BalancePC',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'QC',
            children: [
                {
                    field: 'KgsQCI',
                    header: 'Inventario',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'A',
                    header: 'A',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'B',
                    header: 'B',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'C',
                    header: 'C',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'BalancePCQCA',
                    header: 'Balance',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'IMEX',
            children: [
                {
                    headerName: 'Fechas de Exportación',
                    headerNameEn: 'Export Dates',
                    children: [
                        {
                            field: 'IdPlanExportDate',
                            header: 'Plan Export Date',
                            headerEn: '',
                            Format: 'Date',
                        },
                        {
                            field: 'RevPlanExportDate',
                            header: 'Rev Plan Export Date',
                            Format: 'Date',
                        },
                        {
                            field: 'DateReviewComment',
                            header: 'Date Review Comment',
                            headerEn: '',
                            className: 'XXlarge',
                        },
                        {
                            field: 'IdExportedDate',
                            header: 'Exported Date',
                            headerEn: '',
                            Format: 'Date',
                        },
                        {
                            field: 'Dias',
                            header: 'Dias',
                            headerEn: 'Days',
                            className: 'Xsmall',
                            Format: 'Right'
                        },

                    ]
                },
            ]
        },
        {
            headerName: 'Shipped',
            children: [
                {
                    field: 'KgsEXI',
                    header: 'Inventario',
                    headerEn: 'Inventory',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Kgs',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Yds',
                    header: 'Yds',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Amount',
                    header: 'Amount $',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'OT',
                    header: 'OT',
                    headerEn: '',
                    className: 'small',
                    // Format: 'Currency',
                    // suffix: ' %'
                    Format: 'Template',
                    body: e => barPorcentaje(e, 'OT', colors.colorSintetico)
                },
                {
                    field: 'PD',
                    header: 'PD',
                    headerEn: '',
                    className: 'small',
                    Format: 'Template',
                    body: e => barPorcentaje(e, 'PD', colors.colorCotton)
                },
            ]
        },
        {
            headerName: 'Balance',
            children: [
                {
                    field: 'KgsFB',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'YdsFB',
                    header: 'Yds',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ExPercent',
                    header: 'ExPercent',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Template',
                    body: e => ExPercent(e)
                },
                {
                    field: 'MaxPercent',
                    header: 'Max Percent',
                    className: 'Xsmall',
                    Format: 'Currency',
                },

            ]
        },
    ]

    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
        selected: select,
        setSelected: setSelect
    }

    const columnsDetail = [
        {
            field: 'ProductionCard',
            header: 'PC',
            headerEn: 'PC',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            Format: 'Template',
            body: e => {
                return formatProductionCard(e?.ProductionCard)
            }
        },
        {
            field: 'DyeMachine',
            header: 'Dye Machine',
            headerEn: 'Dye Machine',
            className: '',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'Process',
            header: 'Process',
            headerEn: 'Process',
            className: 'Xsmall',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'Subcategory',
            header: 'Subcategory',
            headerEn: '',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            headerName: 'Order',
            children: [
                {
                    field: 'KgEsperados',
                    header: 'Kgs',
                    headerEn: 'Kgs',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'YdsEsperadas',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Requested',
            children: [
                {
                    field: 'WKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'WYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Batching',
            children: [
                {
                    field: 'GKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'GYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Dyeing',
            children: [
                {
                    field: 'TintoKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'TintoYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Acabado',
            headerEn: 'Finish',
            children: [
                {
                    field: 'AcaGKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'AcaGYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'QC',
            children: [
                {
                    headerName: 'A',
                    children: [
                        {
                            field: 'AcabadoKg',
                            header: 'Kgs',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'AcabadoYd',
                            header: 'Yds',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
                {
                    headerName: 'B',
                    children: [
                        {
                            field: 'ACA_BKg',
                            header: 'Kgs',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'ACA_BYd',
                            header: 'Yds',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                },
                {
                    headerName: 'C',
                    children: [
                        {
                            field: 'ACA_CKg',
                            header: 'Kgs',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: 'ACA_CYd',
                            header: 'Yds',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },

                    ]
                },
            ]
        },
        {
            headerName: 'Export',
            children: [
                {
                    field: 'Estado',
                    header: 'Estado',
                    headerEn: 'Status',
                    className: 'small',
                    Format: 'Template',
                    body: statusTemplate
                },
                {
                    field: 'ExportadoKg',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ExportadoYd',
                    header: 'Yds',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ColorWeek',
                    header: 'Color Week',
                    headerEn: '',
                    className: 'small',
                    Format: 'Center',
                    Center: true
                },
                {
                    field: 'IdColorPlanDate',
                    header: 'Color Plan Date',
                    headerEn: '',
                    Format: 'Date',
                },
                {
                    field: 'IdReadytoshipDate',
                    header: 'Readytoship Date',
                    headerEn: '',
                    Format: 'Date',
                },
                {
                    field: 'IdPlanningDate',
                    header: 'Planning Date',
                    headerEn: '',
                    Format: 'Date',
                },
                {
                    field: 'IdExportedDate',
                    header: 'Exported Date',
                    headerEn: '',
                    Format: 'Date',
                },
                {
                    field: 'Cumplimiento',
                    header: 'Cumplimiento',
                    headerEn: '',
                    className: 'small',
                    Format: 'Center',
                },
                {
                    field: 'DefectName',
                    header: 'Defect Name',
                    headerEn: '',
                    className: '',
                },
                {
                    field: 'ResponsibleArea',
                    header: 'Responsible Area',
                    headerEn: '',
                    className: '',
                },
            ]
        },
    ]

    const tableDetail = {
        Columns: columnsDetail,
        Data: details,
        loading: loading,
        selected: selectedDetail,
        setSelected: setSelectedDetail
    }


    useEffect(() => {
        getInfo();
    }, [get])


    return (
        <div>
            <Toast ref={toast} />
            <div style={{ height: '85vh', }} className='p-3'>
                <AgGrid table={table} />
            </div>
            {/* <Loader loading={loading} /> */}
            <Dialog visible={detail} onHide={onHide} maximizable maximized={true}
                header={<div>
                    {detail?.Customer && <h4>
                        {detail?.Customer} {detail?.Buyer === 'No' ? '' : '-' + detail?.Buyer}
                    </h4>}
                    <div className='d-flex gap' style={{ flexWrap: 'wrap' }}>
                        {/* <h5>Detalle de Producción Cards </h5> */}
                        {detail?.PO && <div>
                            PO: {detail?.PO},
                        </div>}
                        {detail?.SalesOrder && <div>
                            SO: {detail?.SalesOrder},
                        </div>}
                        {detail?.Color && <div>
                            Color: {detail?.Color},
                        </div>}
                        {detail?.Style && <div>
                            Style: {detail?.StyleType} - {detail?.Style},
                        </div>}
                        {detail?.OrderType && <div>
                            {detail?.OrderType}
                        </div>}

                    </div>
                </div>
                }
            >
                <div style={{ height: '85vh', width: '100%' }}>
                    {/* {JSON.stringify(detail, null, 3)} */}
                    <AgGrid table={tableDetail} />
                </div>
            </Dialog>
        </div>
    )
}

export default MasterWipScreen